module.exports = __webpack_public_path__ + "img/12_107.3ae96035.png";